
import {
  SET_HOME_POST,
  FETCH_HOME_POSTS_START,
  FETCH_HOME_POSTS_SUCCESS,
  FETCH_HOME_POSTS_FAILURE,
  SEARCH_USER_START,
  SEARCH_USER_SUCCESS,
  SEARCH_USER_FAILURE,
  FETCH_OTHERS_SINGLE_POST_START,
  FETCH_OTHERS_SINGLE_POST_SUCCESS,
  FETCH_OTHERS_SINGLE_POST_FAILURE,
  FETCH_POST_SUGGESTION_START,
  FETCH_POST_SUGGESTION_SUCCESS,
  FETCH_POST_SUGGESTION_FAILURE,
  FETCH_LISTS_DETAILS_START,
  FETCH_LISTS_DETAILS_SUCCESS,
  FETCH_LISTS_DETAILS_FAILURE,
  UPDATE_POST_LIKES,
  UPDATE_POST_COMMENTS,
  INCREMENT_POST_TIPS_COUNT,
  UPDATE_POST_COMMENTS_COUNT,
  UPDATE_POST_BOOKMARK_STATUS,
  OPEN_UNLOCK_CONTENT_MODAL,
  CLOSE_UNLOCK_CONTENT_MODAL,
  UPDATE_POST_HAS_STORY_STATUS
} from "./ActionConstant";

export function setHomePost(data) {
  return {
    type: SET_HOME_POST,
    data,
  };
}

export function fetchHomePostsStart(data) {
  return {
    type: FETCH_HOME_POSTS_START,
    data,
  };
}

export function fetchHomePostsSuccess(data) {
  return {
    type: FETCH_HOME_POSTS_SUCCESS,
    data,
  };
}

export function fetchHomePostsFailure(error) {
  return {
    type: FETCH_HOME_POSTS_FAILURE,
    error,
  };
}

export function searchUserStart(data) {
  return {
    type: SEARCH_USER_START,
    data,
  };
}

export function searchUserSuccess(data) {
  return {
    type: SEARCH_USER_SUCCESS,
    data,
  };
}

export function searchUserFailure(error) {
  return {
    type: SEARCH_USER_FAILURE,
    error,
  };
}

export function fetchOtherSinglePostStart(data) {
  return {
    type: FETCH_OTHERS_SINGLE_POST_START,
    data,
  };
}

export function fetchOtherSinglePostSuccess(data) {
  return {
    type: FETCH_OTHERS_SINGLE_POST_SUCCESS,
    data,
  };
}

export function fetchOtherSinglePostFailure(error) {
  return {
    type: FETCH_OTHERS_SINGLE_POST_FAILURE,
    error,
  };
}

export function fetchPostSuggesstionStart(data) {
  return {
    type: FETCH_POST_SUGGESTION_START,
    data,
  };
}

export function fetchPostSuggesstionSuccess(data) {
  return {
    type: FETCH_POST_SUGGESTION_SUCCESS,
    data,
  };
}

export function fetchPostSuggesstionFailure(error) {
  return {
    type: FETCH_POST_SUGGESTION_FAILURE,
    error,
  };
}

export function fetchListsDetailsStart(data) {
  return {
    type: FETCH_LISTS_DETAILS_START,
    data,
  };
}

export function fetchListsDetailsSuccess(data) {
  return {
    type: FETCH_LISTS_DETAILS_SUCCESS,
    data,
  };
}

export function fetchListsDetailsFailure(error) {
  return {
    type: FETCH_LISTS_DETAILS_FAILURE,
    error,
  };
}

export function updatePostLikes(data) {
  return {
    type: UPDATE_POST_LIKES,
    data
  }
}

export function updatePostFeedStoryStatus(data) {
  return {
    type: UPDATE_POST_HAS_STORY_STATUS,
    data
  }
}

export function updatePostComments(data) {
  return {
    type: UPDATE_POST_COMMENTS,
    data,
  }
}

export function incrementPostTipCount(data) {
  return {
    type: INCREMENT_POST_TIPS_COUNT,
    data,
  }
}

export function updatePostCommentsCount(data) {
  return {
    type: UPDATE_POST_COMMENTS_COUNT,
    data,
  }
}

export function updatePostBookmarkStatus(data) {
  return {
    type: UPDATE_POST_BOOKMARK_STATUS,
    data,
  }
}

export function openUnlockContentModal(data) {
  return {
    type: OPEN_UNLOCK_CONTENT_MODAL,
    data,
  }
}

export function closeUnlockContentModal (data) {
  return  {
    type: CLOSE_UNLOCK_CONTENT_MODAL,
    data,
  }
}
